export default {
  no_results: {
    title: 'Keine Ergebnisse für "{{search}}"',
    desc: 'Entschuldigung, wir konnten keinen Treffer finden. Bitte versuchen Sie es mit einem anderen Suchbegriff.',
  },
};
